import { TypedDocumentNode, gql } from "@apollo/client";

export interface MenuData {
  menuQuery: {
    menus: MenuInterface[];
    offer: Offer;
  };
}

export const GET_MENUS: TypedDocumentNode<MenuData, MenuVars> = gql`
  query GetMenus($countrySlug: String, $citySlug: String) {
    menuQuery(country_code: $countrySlug, citySlug: $citySlug) {
      menus {
        name
        linkTitle
        slug
        icon
        courses {
          slug
          name
          linkTitle
          icon
          icon_url
          accreditationUrl
          accreditationLogo
          accreditationName
          serviceTrainingDays
          isPopular
          isCertificationProgram
          isSkillBasedCourses
          modeOfTraining
          serviceFlags
          accreditations {
            name
            logo_url
            accreditation_link
          }
          isGenericPageOnly
        }
      }
      offer {
        name
        couponCode
        description
        discountPercentage
        startDate
        endDate
      }
    }
  }
`;
